/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import {GroupNameItem} from 'utils/upsellsUtils'
import {UpsellPriceListSection} from 'pages/Front/Booking/components/PackageUpsell/UpsellPriceListSection'

interface UpsellPriceListProps {
    groups: GroupNameItem[]
    isCompact?: boolean
}

const UpsellPriceList = (props: UpsellPriceListProps) => {
    return (
        <div className="UpsellPriceList flex flex-col gap-4">
            {props.groups?.map((group) => (
                <UpsellPriceListSection
                    key={group.groupName}
                    groupName={group.groupName}
                    subGroups={group.subGroups}
                    isCompact={props.isCompact}
                />
            ))}
        </div>
    )
}

export default UpsellPriceList
